<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <Detaydialog
      v-bind:aktifmi="detayDialogStatus"
      ref="detayDialog"
      :islemTipi="detayDialogIslemTipi"
    ></Detaydialog>
    <loadingcomp
      v-bind:mesaj="loadingmesaj"
      v-model="loadingvmodel"
    ></loadingcomp>
    <filtreDialog
      v-bind:aktifmi="filtreDialogStatus"
      ref="filtreDialog"
      @dialogFilterCancel="dialogFilterCancel($event)"
      @dialogFilterAgree="dialogFilterAgree($event)"
    ></filtreDialog>
    <!-- toolbar -->
    <v-flex xs12 md12 sm12>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{ $t("Booking-List") }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-flex xs12 sm3 md3>
          <v-text-field
            flat=""
            prepend-inner-icon="live_help"
            v-model="Rapor.Filtreler.SearchText"
            solo-inverted=""
            hide-details
            :label=" $t('Search')"
            @click:append="getListPageZero()"
            append-icon="search"
            @keyup.enter="getListPageZero()"
          >
            <v-tooltip slot="prepend-inner" bottom>
              <v-icon slot="activator" color="primary" dark>live_help</v-icon>
              <span> {{ $t("Fields-Which-Can-be-Searched") }} </span><br />
              <v-divider color="yellow"></v-divider>
              <span> {{ $t("PNR-No") }} </span>
            </v-tooltip>
          </v-text-field>
        </v-flex>

        <v-menu bottom origin="center center" transition="scale-transition">
          <v-btn slot="activator" flat>
            <span class="hidden-sm-and-down"> {{ $t("Add") }} </span>
            <v-icon right dark>add_box</v-icon>
          </v-btn>
          <v-list>
            <v-list>
              <a
                target="_self"
                v-bind:href="'#/coper/rezervasyon/index/id?islem=yeni'"
              >
                <v-list-tile>
                  <v-list-tile-title>{{$t('Add-Reservation')}}</v-list-tile-title>
                </v-list-tile>
              </a>
            </v-list>
            <v-list>
              <a
                target="_self"
                v-bind:href="'#/coper/mice/index/id?islem=yeni'"
              >
                <v-list-tile>
                  <v-list-tile-title>{{$t('Add-Mice')}}</v-list-tile-title>
                </v-list-tile>
              </a>
            </v-list>
            <v-list>
              <a target="_self" v-bind:href="'#/coper/vize/yeni/id?islem=yeni'">
                <v-list-tile>
                  <v-list-tile-title
                    >{{ $t("Add-v2", { value: $t("Visa") }) }}
                  </v-list-tile-title>
                </v-list-tile>
              </a>
            </v-list>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-flex>
    <!-- form ınput -->
    <v-flex xs12 sm12 md12>
      <v-form ref="formgunluksatis" lazy-validation>
        <v-card flat class="pa-3">
          <v-layout row>
            <v-flex xs12 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <tarihim
                    :etiket="$t('Starting-Date')"
                    v-model="Rapor.Filtreler.KayitTarihiBasla"
                    :detaygizle="false"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <tarihim
                    :etiket="$t('Finishing-Date')"
                    v-model="Rapor.Filtreler.KayitTarihiBitis"
                    :detaygizle="false"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-select
                    hide-details
                    v-model="Rapor.Filtreler.ParaBirimi"
                    :items="dovizItems"
                    :rules="[(v) => !!v || $t('Mandatory-section')]"
                    item-text="Title"
                    item-value="DovizKod"
                    :label="$t('Currency-Unit')"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-layout>
                    <v-btn color="info" @click="getList()" fab small dark>
                      <v-icon>search</v-icon>
                    </v-btn>
                    <v-badge color="white" :overlap="true">
                      <template v-slot:badge>
                        <v-icon v-if="filtrevarmi" large color="green"
                          >check_circle_outline</v-icon
                        >
                      </template>

                      <v-btn
                        small
                        @mouseenter="tooltip = true"
                        @mouseleave="tooltip = false"
                        ref="fab"
                        @click="filtreOpen()"
                        color="info"
                        fab
                        dark
                      >
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-badge>
                  
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-select
                    hide-details
                    v-model="gitAramaTip"
                    :items="aramaTipItems"
                    item-text="Text"
                    item-value="Value"
                    :label="$t('Search-Type')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-form ref="formPNR" lazy-validation v-if="gitAramaTip=='PNR'">
                    <pnrbul 
                      v-model="searchPnrNo"
                      :rules="[(v) => !!v || $t('Mandatory-section')]"
                      hide-details
                    >
                    </pnrbul>
                  
                  </v-form>
                  <v-form ref="formTakipNo" lazy-validation v-else>
                   
                    <takipno 
                        v-model="searchPnrNo"
                        hide-details
                      >
                      </takipno>
                  </v-form>
                </v-flex>
                <v-flex xs12 sm6 md1 mt-2>
                  <v-btn slot="activator" color="info" @click="gitPNR()">
                    <span class="hidden-sm-and-down"> {{ $t('Go') }} </span>
                    <v-icon right dark>play_arrow</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
             
            </v-flex>
          </v-layout>
        </v-card>
      </v-form>
    </v-flex>

    <!-- Sıralama ve Filtreleme -->
    <v-flex xs12 sm12 md12 pl-3 pr-3>
      <v-card width="100%" flat color="grey lighten-5">
        <v-layout row wrap align-center>
          <v-flex
            xs12
            sm12
            md9
            class="headline font-weight-regular pl-3 grey--text"
          >
            {{ totalCountText }}
          </v-flex>
          <v-flex xs12 sm12 md2 pt-2>
            <v-select
              :label="$t('Sort-By')"
              :items="siralamaItems"
              item-text="Text"
              item-value="Value"
              v-model="Rapor.Paging.SiralamaTip"
              @change="getListPageZero()"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 md1 pt-2>
            <v-select
              :label="$t('Show')"
              :items="veriItem"
              item-text="Text"
              item-value="Value"
              v-model="Rapor.Paging.VeriAdet"
              @change="getListPageZero()"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <!--listeleme-->
    <v-container fluid grid-list-sm>
      <v-flex
        v-for="item in cardItems"
        v-bind:key="item.SiraNo"
        pb-3
        xs12
        sm12
        md12
      >
        <v-hover>
          <v-card
            width="100%"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="elevation-1 pt-3 pl-3 pb-3"
          >
            <v-layout row wrap align-center justify-end>
              <v-flex xs12 sm6 md3>
                <v-layout row wrap>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-medium grey--text caption"
                        v-on="on"
                      >
                        <v-icon color="red" v-if="item.Deleted" small
                          >remove_circle</v-icon
                        >

                        <v-icon color="#67768f" small v-if="!item.Deleted"
                          >check_circle</v-icon
                        >

                        {{ item.PNR_No }}
                        <v-icon
                          color="#67768f"
                          v-if="item.TakipNo != null && !item.Deleted"
                          small
                          >check_circle</v-icon
                        >
                        <v-icon
                          color="red"
                          v-if="item.TakipNo != null && item.Deleted"
                          small
                          >remove_circle</v-icon
                        >
                        {{ item.TakipNo }}
                      </v-flex>
                    </template>
                    <span> {{ $t("Booker") }} : {{ item.RezYapan }} </span> <br/>
                    <span> {{ $t("Person-Offering-Booking") }} : {{ item.RezVeren }} </span> <br/>
                    <span> {{ $t("Expense-Center") }}  :   {{ item.PNR_MasrafMerkezi }} </span>
                  </v-tooltip>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-medium grey--text caption"
                  >
                    <v-icon color="#67768f" small>supervisor_account</v-icon>
                    {{ item.Isim }}
                    <!-- <v-btn flat small icon @click="nameListOpen(item)">
                      <v-icon>more_horiz</v-icon>
                    </v-btn> -->
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="font-weight-bold grey--text caption"
                  >
                    <v-icon color="#67768f" small>payment</v-icon>
                    {{ item.CariKod }} / {{ item.Unvan }}
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-medium grey--text caption"
                  style="color: #67768f"
                >
                  <span style="color: #67768f">{{$t('Record')}} :</span>
                  {{ item.KayitTarihi | dateformat }}
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-medium grey--text caption"
                  style="color: #67768f"
                >
                  <span style="color: #67768f">{{$t('Check-In')}} :</span>
                  {{ item.IlkGiris | dateformat }}
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-medium grey--text caption"
                  style="color: #67768f"
                >
                  <span style="color: #67768f">{{$t('Check-Out')}} :</span>
                  {{ item.SonCikis | dateformat }}
                </v-flex>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-layout row wrap>
                  <v-flex xs12 sm2 md1>
                    <v-badge color="white" left overlap>
                      <template v-slot:badge>
                        <v-icon
                          v-if="
                            item.TurOperator != null &&
                            item.TurOperator != 'STD'
                          "
                          color="red"
                          small
                        >
                          bookmark
                        </v-icon>
                      </template>
                      <v-icon color="info" left medium>
                        {{ item.SaticiTip | getIconName(SaticiIconList) }}
                      </v-icon>
                    </v-badge>
                  </v-flex>
                  <v-flex xs12 sm10 md11>
                    <v-flex
                      xs12
                      sm12
                      md12
                      class="font-weight-large grey--text pl-3 caption"
                    >
                      {{ item.SaticiAd }}
                      <!-- <v-btn flat small icon @click="salesListOpen(item)">
                        <v-icon>more_horiz</v-icon>
                      </v-btn> -->
                    </v-flex>
                  </v-flex>
                  <v-flex
                    v-if="item.FaturaNo != null"
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text caption"
                    ><span style="color: #67768f"
                      >{{ $t("Invoice-Date") }}: &nbsp;&nbsp;&nbsp;&nbsp;:</span
                    >
                    {{ item.FaturaTarih | dateformat }}</v-flex
                  >
                  <v-flex
                    v-if="item.FaturaNo != null"
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text caption"
                    ><span style="color: #67768f"
                      >{{ $t("Invoice-No") }} &nbsp;&nbsp;&nbsp;&nbsp;:</span
                    >
                    {{ item.FaturaNo }}</v-flex
                  >
                  <v-flex
                    v-if="item.FaturaNo == null"
                    xs12
                    sm12
                    md12
                    class="font-weight-large grey--text caption"
                  >
                    <v-chip label outline color="red">{{$t('Invoice-Not-Printed')}}</v-chip>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text caption"
                  ><span style="color: #67768f"> {{ $t('Purchase-Total') }} :</span>
                  {{ item.Alis | moneyformat }} {{ selectedCurrency }} ({{
                    item.AlisTL | moneyformat
                  }}
                  TL)
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  class="font-weight-large grey--text caption"
                  ><span style="color: #67768f">{{$t('Received-Coms.-Total')}}:</span>
                  {{ item.Komisyon | moneyformat }} {{ selectedCurrency }} ({{
                    item.KomisyonTL | moneyformat
                  }}
                  TL)
                </v-flex>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <v-flex
                  xs12
                  sm12
                  md12
                  style="color: #67768f"
                  class="
                    font-weight-regular
                    headline
                    text-sm-left text-xs-left text-lg-center text-md-center
                  "
                  >{{ item.Satis | moneyformat }} {{ selectedCurrency }}</v-flex
                >
                <v-flex
                  xs12
                  sm12
                  md12
                  style="color: #67768f"
                  class="
                    font-weight-regular
                    subtitle
                    text-sm-left text-xs-left text-lg-center text-md-center
                  "
                  >({{ item.SatisTL | moneyformat }} TL)</v-flex
                >
              </v-flex>

              <v-flex xs12 sm6 md1>
                <v-layout row wrap>
                  <v-flex xs6 sm6 md6 shrink>
                    <v-tooltip bottom>
                      <v-btn
                        icon
                        medium
                        slot="activator"
                        flat
                        @click="git(item)"
                        :disabled="item.Deleted"
                      >
                        <v-icon color="info" medium git>search</v-icon>
                      </v-btn>
                      <span>Detay</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs6 sm6 md6 v-if="!item.Deleted">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark flat icon v-on="on">
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-title>
                            <a
                              icon
                              small
                              slot="activator"
                              flat
                              :href="
                                '#/coper/page/formlar/voucher/id?islem=get&Tip='+ item.SaticiTip +'&PNR_No=' +
                                item.PNR_No
                              "
                              target="_blank"
                            >
                              Voucher
                            </a>
                          </v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile>
                          <v-list-tile-title>
                            <a
                              icon
                              small
                              slot="activator"
                              flat
                              :href="
                                '#/coper/page/formlar/otelrezervasyonfisi/id?islem=get&PNR_No=' +
                                item.PNR_No +
                                '&rezType=1'
                              "
                              target="_blank"
                            >
                              {{ $t('Reservation-Bill') }}
                            </a>
                          </v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile>
                          <v-list-tile-title>
                            <a
                              icon
                              small
                              slot="activator"
                              flat
                              :href="
                                '#/coper/page/formlar/otelrezervasyonfisi/id?islem=get&PNR_No=' +
                                item.PNR_No +
                                '&rezType=2'
                              "
                              target="_blank"
                            >
                               {{ $t('Reservation-Cancellation-Bill') }} 
                            </a>
                          </v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile>
                          <v-list-tile-title>
                            <a
                              icon
                              small
                              slot="activator"
                              flat
                              :href="
                                '#/coper/page/formlar/otelrezervasyonfisi/id?islem=get&PNR_No=' +
                                item.PNR_No +
                                '&rezType=3'
                              "
                              target="_blank"
                            >
                             {{ $t('Reservation-Change-Bill') }} 
                            </a>
                          </v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile  v-if="item.TakipNo != null">
                          <v-list-tile-title>
                            <a
                              icon
                              small
                              slot="activator"
                              flat
                              :href="
                                '#/coper/page/formlar/kotasyonformu/id?islem=get&Tip=2&PNR_No=' +
                                item.TakipNo
                              "
                              target="_blank"
                            >
                              {{ $t("Quotation-Form") }}
                            </a>
                          </v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile  v-if="item.TakipNo == null">
                          <v-list-tile-title>
                            <a
                              icon
                              small
                              slot="activator"
                              flat
                              :href="
                                '#/coper/page/formlar/kotasyonformu/id?islem=get&Tip=1&PNR_No=' +
                                item.PNR_No
                              "
                              target="_blank"
                            >
                              {{ $t("Quotation-Form") }}
                            </a>
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-hover>
      </v-flex>
    </v-container>

    <!-- sayfalama -->
    <template v-if="vmodelpagination">
      <div class="text-xs-center">
        <v-container>
          <v-layout justify-center>
            <v-flex xs8>
              <v-pagination
                :disabled="paginationDisabled"
                color="info"
                v-model="sayfalama"
                :length="pagenumber"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
  </div>
</template>

<script>
import tool from "@/components/app/coper/tools";
import tarihim from "@/components/app/customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "../../../../api/auth";
import Detaydialog from "./comp/detaydialog.vue";
import filtreDialog from "./comp/filtredialog.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import takipno from "@/components/app/coper/component/takipno.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
//import { EventBus } from '@/event-bus';

export default {
  data() {
    return {
      gitAramaTip:"PNR",
      searchPnrNo: null,
      filtrevarmi: false,
      el: null,
      tooltip: false,
      filtreDialogStatus: false,
      loadingmesaj: "",
      loadingvmodel: false,
      detayDialogIslemTipi: 0,
      detayDialogStatus: false,
      selectedCurrency: null,
      dovizItems: [],
      cardItems: [],
      totalCountText: null,
      paginationDisabled: false,
      vmodelpagination: false,
      sayfalama: 1,
      pagenumber: 1,
      text1: "",
      snackbar: false,
      aramaTipItems:[
        {
          Text:"PNR",
          Value:"PNR"
        },
        {
          Text:"Takip No",
          Value:"TakipNo"
        }
      ],
      veriItem: [
        {
          Text: "25",
          Value: 25,
        },
        {
          Text: "50",
          Value: 50,
        },
        {
          Text: "100",
          Value: 100,
        },
      ],
      siralamaItems: [
        {
          Text: this.$t('PNR-Number-Ascending'),
          Value: 0,
        },
        {
          Text: this.$t('PNR-Number-Descending'),
          Value: 1,
        },
        {
          Text: this.$t('Record-Date-Ascending'),
          Value: 2,
        },
        {
          Text: this.$t('Record-Date-Descending'),
          Value: 3,
        },
        {
          Text: this.$t('Current-Code-Ascending'),
          Value: 4,
        },
        {
          Text: this.$t('Current-Code-Descending'),
          Value: 5,
        },
        {
          Text: this.$t('Check-In-Date-Ascending'),
          Value: 6,
        },
        {
          Text: this.$t('Check-In-Date-Descending'),
          Value: 7,
        },
        {
          Text: this.$t('Check-Out-Date-Ascending'),
          value: 8,
        },
        {
          Text: this.$t('Check-Out-Date-Ascending'),
          value: 9,
        },
      ],
      Rapor: {
        Filtreler: {
          KayitTarihiBasla: null,
          KayitTarihiBitis: null,
          ParaBirimi: "TL",
          TakipNo: null,
          SearchText: null,
          Prm: {
            PCariKod: null,
            PPNR_No: null,
            PSirketNo: null,
            PCariSirket: null,
            PPNR_ParaBirimi: null,
            PKayitTarihBas: null,
            PKayitTarihBit: null,
            PDonem1Bas: null,
            PDonem1Bit: null,
            PDonem2Bas: null,
            PDonem2Bit: null,
            PFatTarihBas: null,
            PFatTarihBit: null,
            PKomFatTarihBas: null,
            PKomFatTarihBit: null,
            PSaticiTip: null,
            PSaticiKod: null,
            PDosyaTip: null,
            PDosya: null,
            PAcente: null,
            PPNRBir: null,
            PCariHesapGrubu: null,
            PCariTip: null,
            PSaticiGrup: null,
            PSaticiIc_Dis: null,
            PTurOp: null,
            PFaturali: null,
            POpsiyon: null,
            PAnaTip: null,
            PCariAnaHesap: null,
            PIptalRaporu: null,
            PIptalDahil: true,
            PRezGrupID: null,
            PSatisGrubu: null,
            PSatisGrupTip: null,
            PSaticiOdemesiHesapla: null,
            PMasrafMerkezi: null,
            PAcenteDepartmanID: null,
            PPozisyonNo: null,
            PSatisFaturaNo: null,
            PMusteriOdemelilerHaric: null,
            PReferans: null,
            PSatisTip1: null,
            PSatisTip2: null,
            PSatisTip3: null,
            PSatisTip4: null,
            PGelenFatTarihBas: null,
            PGelenFatTarihBit: null,
            PProfilSablonId: null,
            PKomisyonFaturali: null,
            PGelenFaturali: null,
          },
        },
        Paging: {
          SiralamaTip: 0,
          SayfaNo: 1,
          VeriAdet: 25,
        },
      },
      SaticiIconList: [
        {
          IconName: "hotel",
          Kod: 1,
        },
        {
          IconName: "rv_hookup",
          Kod: 2,
        },
        {
          IconName: "restaurant",
          Kod: 3,
        },
        {
          IconName: "local_see",
          Kod: 4,
        },
        {
          IconName: "departure_board",
          Kod: 5,
        },
        {
          IconName: "emoji_people",
          Kod: 6,
        },
        {
          IconName: "museum",
          Kod: 7,
        },
        {
          IconName: "flight_takeoff",
          Kod: 8,
        },
        {
          IconName: "directions_boat",
          Kod: 9,
        },
        {
          IconName: "category",
          Kod: 10,
        },
        {
          IconName: "style",
          Kod: 11,
        },
        {
          IconName: "tour",
          Kod: 12,
        },
        {
          IconName: "meeting_room",
          Kod: 13,
        },
        {
          IconName: "verified_user",
          Kod: 14,
        },
        {
          IconName: "directions_boat",
          Kod: 15,
        },
        {
          IconName: "golf_course",
          Kod: 16,
        },
      ],
    };
  },
  methods: {
    getList() {
      if (this.$refs.formgunluksatis.validate()) {

        this.loadingvmodel = true;
        var _bastarih = new Date(this.Rapor.Filtreler.KayitTarihiBasla);
        var _bittarih = new Date(this.Rapor.Filtreler.KayitTarihiBitis);

        if (_bastarih <= _bittarih) {
          var _credentials = JSON.parse(
            window.localStorage.getItem("credentials")
          );
          if (this.Rapor.Filtreler.Prm.PSaticiKod != null) {
            this.Rapor.Filtreler.Prm.PSaticiKod =
              this.Rapor.Filtreler.Prm.PSaticiKod.kod;
          }
          this.Rapor.Paging.SiralamaTip = this.Rapor.Paging.SiralamaTip;
          this.Rapor.Paging.SayfaNo = this.sayfalama;
          this.Rapor.Paging.VeriAdet = this.Rapor.Paging.VeriAdet;

          this.Rapor.Filtreler.Prm.PCariSirket = _credentials.SirketKodu;
          this.Rapor.Filtreler.Prm.PSirketNo = _credentials.CoperSirketNo;
         
          if (this.Rapor.Filtreler.Prm.PTurOp != null) {
            this.Rapor.Filtreler.Prm.PTurOp =
            this.Rapor.Filtreler.Prm.PTurOp.kod;
          }
          if (this.Rapor.Filtreler.Prm.PMasrafMerkezi!=null && this.Rapor.Filtreler.Prm.PMasrafMerkezi!="undefined" && this.Rapor.Filtreler.Prm.PMasrafMerkezi!="")
          {
            var mkod=this.Rapor.Filtreler.Prm.PMasrafMerkezi.kod;
            this.Rapor.Filtreler.Prm.PMasrafMerkezi=mkod;
          }


          tool.http_post(this, "GunlukSatisListPaging", this.Rapor).then(
            (response) => {
              if (response.body.Status == true) {
                this.pagenumber = response.body.PageTotals.TotalPage;
                if (response.body.PageTotals.TotalCount > 0) {
                  this.totalCountText =
                    this.$t('Total') + " " +
                    response.body.PageTotals.TotalCount +  " " + this.$t('Number-of-Records-Found');
                   
                } else {
                  this.totalCountText = this.$t("No-Records-Found");
                }

                this.selectedCurrency = this.Rapor.Filtreler.ParaBirimi;
                this.vmodelpagination = true;

                this.cardItems = response.body.data;
                this.loadingvmodel = false;
              } else {
                this.text1 = response.body.ErrorList[0];
                this.snackbar = true;
                this.loadingvmodel = false;

              }
            },
            (response) => {
              //EventBus.$emit('openResultDialog',{"response":response,"request":this.Rapor,"api": "GunlukSatisListPaging","type":1,"message":"Satış Listesi Getirilemedi"});
              this.HataYonetimi(response, this.Rapor, "Satış Listesi Getirilemedi");
              this.progress = false;
              this.load1 = true;
              this.loadingvmodel = false;
            }
          );
        } else {
          this.text1 = this.$t("start-date-cannot-greater-than-end-date");
          this.snackbar = true;
        }
      }
    },
    getListPageZero() {
      this.sayfalama = 1;
      this.getList();
    },
    gitTakipNo() {
      let RaporPrm= {
        Filtreler: {
          KayitTarihiBasla: null,
          KayitTarihiBitis: null,
          ParaBirimi: "TL",
          TakipNo: this.searchPnrNo,
          SearchText: null,
          Prm: {
            PCariKod: null,
            PPNR_No: null,
            PSirketNo: null,
            PCariSirket: null,
            PPNR_ParaBirimi: null,
            PKayitTarihBas: null,
            PKayitTarihBit: null,
            PDonem1Bas: null,
            PDonem1Bit: null,
            PDonem2Bas: null,
            PDonem2Bit: null,
            PFatTarihBas: null,
            PFatTarihBit: null,
            PKomFatTarihBas: null,
            PKomFatTarihBit: null,
            PSaticiTip: null,
            PSaticiKod: null,
            PDosyaTip: null,
            PDosya: null,
            PAcente: null,
            PPNRBir: null,
            PCariHesapGrubu: null,
            PCariTip: null,
            PSaticiGrup: null,
            PSaticiIc_Dis: null,
            PTurOp: null,
            PFaturali: null,
            POpsiyon: null,
            PAnaTip: null,
            PCariAnaHesap: null,
            PIptalRaporu: null,
            PIptalDahil: true,
            PRezGrupID: null,
            PSatisGrubu: null,
            PSatisGrupTip: null,
            PSaticiOdemesiHesapla: null,
            PMasrafMerkezi: null,
            PAcenteDepartmanID: null,
            PPozisyonNo: null,
            PSatisFaturaNo: null,
            PMusteriOdemelilerHaric: null,
            PReferans: null,
            PSatisTip1: null,
            PSatisTip2: null,
            PSatisTip3: null,
            PSatisTip4: null,
            PGelenFatTarihBas: null,
            PGelenFatTarihBit: null,
            PProfilSablonId: null,
            PKomisyonFaturali: null,
            PGelenFaturali: null,
          },
        },
        Paging: {
          SiralamaTip: 0,
          SayfaNo: 1,
          VeriAdet: 25,
        },
      };
      tool.http_post(this, "GunlukSatisListPaging", RaporPrm).then(
            (response) => {
              if (response.body.Status == true) {
                this.pagenumber = response.body.PageTotals.TotalPage;
                if (response.body.PageTotals.TotalCount > 0) {
                  this.loadingvmodel = false;
                  let url = "#/coper/vize/yeni/id?islem=get&TakipNo=" + this.searchPnrNo;
                  window.open(url, "_target");
                } else {
                  this.loadingvmodel = false;
                  this.text1 = 'Takip No Bulunamadı';
                  this.snackbar = true;
                }

               
                
              } else {
                this.text1 = response.body.ErrorList[0];
                this.snackbar = true;
                this.loadingvmodel = false;

              }
            },
            (response) => {
              //EventBus.$emit('openResultDialog',{"response":response,"request":this.Rapor,"api": "GunlukSatisListPaging","type":1,"message":"Satış Listesi Getirilemedi"});
              this.HataYonetimi(response, this.Rapor, "Takip No Bulunamadı");
              this.progress = false;
              this.load1 = true;
              this.loadingvmodel = false;
            }
          );
    },
    gitPNR() {
      if (this.gitAramaTip=="PNR")
      {
        if (this.$refs.formPNR.validate()) {
        this.loadingvmodel = true;
        let params = {
          PNR_No: this.searchPnrNo,
        };
        this.loadingvmodel = true;
        tool.http_post(this, "RezervasyonLoad", params).then(
          (response) => {
            if (response.body.Status == true) {
              if (response.body.data != null) {
                this.loadingvmodel = false;
                var url =
                  "#/coper/rezervasyon/index/id?islem=get&PNR_No=" +
                  this.searchPnrNo;
                window.open(url, "_target");
              }
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          },
          (response) => {
            this.HataYonetimi(response, params, "Rezervasyon Getirilemedi");
          }
        );
      }
      }
      else
      {
        this.gitTakipNo();
      }
     
    },
    git(val) {
      if (val.SatisGrupTip === 1) {
        let url = "#/coper/vize/yeni/id?islem=get&TakipNo=" + val.TakipNo;
        window.open(url, "_target");
      } 
      else if (val.SatisGrupTip === 3)
        {
        let url = "#/coper/mice/index/id?islem=get&TakipNo=" + val.TakipNo;
        window.open(url, "_target");
      }
      else {
        let url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
        window.open(url, "_target");
      }
    },
    dialogFilterCancel(cancelFilterValue) {
      this.Rapor = Object.assign(this.Rapor, cancelFilterValue);
    },
    dialogFilterAgree(agreeFilterValue) {
      this.Rapor = Object.assign(this.Rapor, agreeFilterValue);
      this.Rapor.Filtreler.Prm.PPNRBir ? this.Rapor.Filtreler.Prm.PPNRBir = this.Rapor.Filtreler.Prm.PPNRBir.kod : this.Rapor.Filtreler.Prm.PPNRBir = null; 
      this.sayfalama = 1;
      this.getList();
      this.filtrevarmi = true;
      this.$refs.filtreDialog.close();
    },
    filtreOpen() {
      this.filtreDialogStatus = true;
      this.$refs.filtreDialog.open(this.Rapor);
    },
    salesListOpen(value) {
      this.detayDialogIslemTipi = 1;
      this.detayDialogStatus = true;
      this.$refs.detayDialog.open(value);
    },
    nameListOpen(value) {
      this.detayDialogIslemTipi = 0;
      this.detayDialogStatus = true;
      this.$refs.detayDialog.open(value);
    },
  },
  components: {
    tarihim,
    Detaydialog,
    loadingcomp,
    filtreDialog,
    pnrbul,
    takipno,
    snackbarcomp,
    yetkidialog,
  },
  watch: {
    sayfalama() {
      this.getList();
    },
  },
  filters: {
    getIconName: function (t, iconList) {
      var _iconValue = t.split(" - ");
      let _resultIcon = null;
      iconList.forEach((element) => {
        if (element.Kod == _iconValue[0]) {
          _resultIcon = element.IconName;
        }
      });
      return _resultIcon;
    },
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.el = this.$refs.fab.$el;
    
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params = {
        CompanyCode: credentials.SirketKodu,
      };
      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.dovizItems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
};
</script>

<style scoped>
.boyutSpan {
  width: 125px;
}
</style>
